import { useRouter } from 'next/router';
import twoGlasses from '~/assets/img/illustrations/Stat_wine_left.svg';
import threeGlasses from '~/assets/img/illustrations/Stat_wine_right.svg';
import Champagne from '~/assets/img/illustrations/Champagne.svg';
import Bordeaux from '~/assets/img/illustrations/Bordeaux.svg';
import Piedmont from '~/assets/img/illustrations/Piedmont.svg';
import Tuscany from '~/assets/img/illustrations/Tuscany.svg';
import California from '~/assets/img/illustrations/California.svg';
import WalaWalaValley from '~/assets/img/illustrations/WalaWalaValley.svg';
import MoselSvgImport from '~/assets/img/illustrations/Mosel.svg';
import RestOfTheWorld from '~/assets/img/illustrations/RestOfTheWorld.svg';
import Australia from '~/assets/img/illustrations/Australia.svg';

export const useRegionImages = () => {
    const router = useRouter();

    const hero = {
        img1: {
            src: twoGlasses.src,
            width: 216,
            height: 308
        },
        img2: {
            src: threeGlasses.src,
            width: 245,
            height: 326
        }
    };
    switch (router.asPath) {
        case '/trade/france':
        case '/trade/france/rhone':
        case '/trade/france/burgundy':
        case '/trade/france/bordeaux':
        case '/trade/france/champagne':
            hero.img1.src = Champagne.src;
            hero.img1.width = 600;
            hero.img1.height = 664;
            hero.img2.src = Bordeaux.src;
            hero.img2.width = 600;
            hero.img2.height = 664;
            break;
        case '/trade/italy':
        case '/trade/italy/piedmont':
        case '/trade/italy/tuscany':
            hero.img1.src = Piedmont.src;
            hero.img1.width = 600;
            hero.img1.height = 664;
            hero.img2.src = Tuscany.src;
            hero.img2.width = 600;
            hero.img2.height = 664;
            break;
        case '/trade/united-states':
        case '/trade/united-states/california':
        case '/trade/united-states/walla-walla-valley':
            hero.img1.src = California.src;
            hero.img1.width = 600;
            hero.img1.height = 664;
            hero.img2.src = WalaWalaValley.src;
            hero.img2.width = 600;
            hero.img2.height = 664;
            break;
        case '/trade/germany':
        case '/trade/germany/mosel':
            hero.img1.src = MoselSvgImport.src;
            hero.img1.width = 600;
            hero.img1.height = 664;
            hero.img2.src = RestOfTheWorld.src;
            hero.img2.width = 600;
            hero.img2.height = 664;
            break;
        case '/trade/australia':
        case '/trade/australia/south-australia':
            hero.img1.src = Australia.src;
            hero.img1.width = 600;
            hero.img1.height = 664;
            hero.img2.src = Australia.src;
            hero.img2.width = 600;
            hero.img2.height = 664;
            break;
        default:
            hero.img1.src = twoGlasses.src;
            hero.img1.width = 216;
            hero.img1.height = 308;
            hero.img2.src = threeGlasses.src;
            hero.img2.width = 245;
            hero.img2.height = 326;
    }

    return {
        hero
    };
};
